import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export const ProtectedRoute = ({ children, requireAccess = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zita-mocha">
        <div className="animate-pulse text-lg">Loading Zita…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // Doctrine v2.0: gated routes bounce to /subscribe (the paywall), not the
  // marketing /billing page. Super Admin always has access.
  if (requireAccess && !user.has_active_access) {
    return <Navigate to="/subscribe" state={{ from: location }} replace />;
  }
  return children;
};
